import React from 'react'
import Form from 'react-bootstrap/Form';
import { CheckCircle } from 'react-feather';

const InputField = ({inputFieldLabel, requiredStar,onChange,value,name}) => {
  return (
    <>
     <Form.Label className='form-label'>{inputFieldLabel} <span className='redStar'>{requiredStar}</span></Form.Label>
      <Form.Control
        type="password"
        onChange ={onChange}
        value={value}
        name={name}
        
      /> 
      {/* {isMatch && <CheckCircle color="green" size={20} />}   */}
    </>
  )
}

export default InputField